import ChatDetailFooter from './ChatDetailFooter';

export default ChatDetailFooter;
